export const config = {
  appName: import.meta.env.VITE_APP_NAME ?? 'Zertteu Academy',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
} as const;

export const storageKeys = {
  locale: 'zertteu.locale',
  theme: 'zertteu.theme',
  session: 'zertteu.session',
  token: 'zertteu.token',
  boardSession: 'zertteu.board.session',
  accessRequest: 'zertteu.access.request',
  trustedDevice: 'zertteu.classroom.device',
  navReturnTo: 'zertteu.nav.returnTo',
} as const;
